import { controlToastState } from "risa-oasis-ui_v2";
import { PushToSftpTableDataModel } from "../../../../data-model/pushToSftpDataModel";
import { PushToSftpModalTableColumnKeys } from "../../../../enums/tableColumnKeys";
import { closeModal } from "../../../../redux/slice/modalSliceNew";
import { AppDispatch } from "../../../../redux/store/store";
import { logError } from "../../../../utils/customLogger";

/**
 * Handler for Track Status action
 * This is called when the modal is in 'track' mode
 * Returns an object with the promise and an abort function to cancel the timeout
 */
export const onTrackStatus = (
  tableData: PushToSftpTableDataModel[],
  dispatch: AppDispatch,
  runTrackStatus: (...args: any[]) => Promise<any>,
): { promise: Promise<void>; abort: () => void } => {
  const selectedData = tableData.filter(
    (item) => item[PushToSftpModalTableColumnKeys.SELECT]?.isChecked,
  );

  if (selectedData.length === 0) {
    controlToastState("track-status-no-selection");
    return {
      promise: Promise.resolve(),
      abort: () => {},
    };
  }

  const selectedFilenames = selectedData
    .map((item) => item[PushToSftpModalTableColumnKeys.FILENAME])
    .filter((filename): filename is string => filename !== undefined);

  if (selectedFilenames.length === 0) {
    controlToastState("track-status-no-selection");
    return {
      promise: Promise.resolve(),
      abort: () => {},
    };
  }

  // Start API call in background (don't wait for it)
  runTrackStatus(selectedFilenames).catch(() => {
    controlToastState("track-status-error");
    logError(
      new Error("Error running track status"),
      "Error running track status",
    );
  });

  let timeoutId: NodeJS.Timeout | null = null;
  let isAborted = false;

  // Wait exactly 5 seconds, then show toast and close modal
  const promise = new Promise<void>((resolve) => {
    timeoutId = setTimeout(() => {
      if (!isAborted) {
        controlToastState("track-status-success");
        dispatch(closeModal());
      }
      resolve(undefined);
    }, 5000);
  });

  const abort = () => {
    isAborted = true;
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  return { promise, abort };
};
